import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

function Header({ content, reference }) {
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: content }} ref={reference} />;
}

Header.propTypes = {
  content: PropTypes.string.isRequired,
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }) // eslint-disable-line react/forbid-prop-types
  ]).isRequired
};

const useHeaderSsr = ({C4PHeader, useAuth, onSignin, config}) => {
  const headerEl = useRef(null);
 
  useEffect(() => {
    const props = {useAuth, onSignin, config};
    ReactDOM.hydrate(<C4PHeader {...props} />, headerEl.current);
  }, [C4PHeader, useAuth, onSignin, config]);

  return { Header, reference: headerEl };
};

export default useHeaderSsr;
